// Must match the amount the backend charges the wallet: TripServices.GetSegmentsAmountAndCurrency.
const getWalletChargeAmount = (tripSegments, modes) =>
  (tripSegments || [])
    .filter(({ mode, itinerary }) => (modes || []).includes(mode) && itinerary?.cost?.price > 0)
    .reduce((amount, { itinerary: { cost } }) => {
      const segmentAmount =
        cost.doShowMarkupAmount && cost.markupPrice > 0 ? cost.markupPrice : cost.price;

      return amount + segmentAmount;
    }, 0);

export default getWalletChargeAmount;
